// extracted by mini-css-extract-plugin
module.exports = {"divider":"ReviewedBanner_divider__3PO4J","reviewedIcon":"ReviewedBanner_reviewedIcon__2wHeM","reviewedCard":"ReviewedBanner_reviewedCard__loR9N"};